import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const KeywordManager = () => {
  const [type, setType] = useState("");
  const [keyword, setKeyword] = useState("");
  const [rowData, setRowData] = useState([]);
  const [errors, setErrors] = useState("");
  const [editingKeyword, setEditingKeyword] = useState(null);
  const [alert, setAlert] = useState({ message: "", type: "" }); // Alert state

  useEffect(() => {
    axios
      // .get("http://localhost:3036/keyword")
      .get(`${API_BASE_URL}/keyword`)
      // .get("https://calendarservicesapi.nithra.mobi/keyword")
      .then((response) => {
        setRowData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);



    useEffect(() => {
          document.title = 'Keyword - Calendar Services';
        }, []);


  useEffect(() => {
    if (alert.message) {
      const timer = setTimeout(() => setAlert({ message: "", type: "" }), 3000);
      return () => clearTimeout(timer);
    }
  }, [alert]);




  const columnDefs = [
    { headerName: "S.No", valueGetter: (params) => params.node.rowIndex + 1 },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <div className="flex space-x-2">
          <button
            className="text-blue-500 hover:underline"
            onClick={() => handleEdit(params.data)}
          >
            Edit
          </button>
          <button
            className="text-red-500 hover:underline"
            onClick={() => handleDelete(params.data)}
          >
            Delete
          </button>
        </div>
      ),
    },
    { headerName: "Keyword Name", field: "keyword", flex: 1 },
    { headerName: "Type", field: "type", flex: 1 },
  ];

  const handleSave = () => {
    const loggedInUser = localStorage.getItem("username");

    if (!type.trim() || !keyword.trim()) {
      setErrors("Both Type and Keyword are required.");
      return;
    }

    if (editingKeyword) {
      const updatedKeyword = { id: editingKeyword.id, type, keyword, mby: loggedInUser };

      axios
        // .put(`http://localhost:3036/keyword/${editingKeyword.id}`, updatedKeyword)
        .put(`${API_BASE_URL}/keyword/${editingKeyword.id}`, updatedKeyword)
        // .put(`https://calendarservicesapi.nithra.mobi/keyword/${editingKeyword.id}`, updatedKeyword)
        .then(() => {
          setRowData((prevData) =>
            prevData.map((row) =>
              row.id === editingKeyword.id ? { ...row, type, keyword } : row
            )
          );
          resetForm();
          setAlert({ message: "Keyword updated successfully!", type: "success" });
        })
        .catch((error) => {
          console.error("Error updating keyword:", error);
          setAlert({ message: "Error updating keyword.", type: "error" });
        });
    } else {
      const newKeyword = { type, keyword, cby: loggedInUser };

      axios
        // .post("http://localhost:3036/keyword", newKeyword)
        .post(`${API_BASE_URL}/keyword`, newKeyword)
        // .post("https://calendarservicesapi.nithra.mobi/keyword", newKeyword)
        .then((response) => {
          setRowData((prevData) => [...prevData, { ...newKeyword, id: response.data.id }]);
          resetForm();
          setAlert({ message: "Keyword added successfully!", type: "success" });
        })
        .catch((error) => {
          console.error("Error adding keyword:", error);
          setAlert({ message: "Error adding keyword.", type: "error" });
        });
    }
  };

  const handleEdit = (keyword) => {
    setEditingKeyword(keyword);
    setType(keyword.type);
    setKeyword(keyword.keyword);
    setErrors("");
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };

  const handleDelete = (id) => {
    
    if (window.confirm("Are you sure you want to delete this keyword?")) {
      axios
        .delete(`https://calendarservicesapi.nithra.mobi/keyword/${id}`)
        .then(() => {
          setRowData((prevData) => prevData.filter((row) => row.id !== id));
          setAlert({ message: "Keyword deleted successfully!", type: "success" });
        })
        .catch((error) => {
          console.error("Error deleting keyword:", error);
          setAlert({ message: "Error deleting keyword.", type: "error" });
        });
    }
  };

  const resetForm = () => {
    setEditingKeyword(null);
    setType("");
    setKeyword("");
    setErrors("");
  };

  return (
    <div className="bg-gray-100 p-6">
      <div className="max-w-3xl mx-auto mt-8 bg-white shadow-md rounded mb-4">
        <div className="bg-teal-500 text-white px-6 py-3 rounded-t">
          <h2 className="text-xl font-bold">Add Keyword</h2>
        </div>
        <div className="p-4">
          <div>
            <label className="block text-gray-700 font-semibold mb-4">
              Keyword Type<span className="text-red-500">*</span>
            </label>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <select
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  className="w-full p-3 border rounded mt-2"
                >
                  <option value="">Select Type</option>
                  <option value="ஜோதிடர்">ஜோதிடர்</option>
                  <option value="ஐயர்">ஐயர்</option>
                  <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
                  <option value="எண்கணிதம்">எண்கணிதம்</option>
                  <option value="சிற்பி">சிற்பி</option>
                  <option value="விபூதி தயாரிப்பவர்">விபூதி தயாரிப்பவர்</option>
                  <option value="ஆன்மீக சொற்பொழிவாளர்">
                    ஆன்மீக சொற்பொழிவாளர்
                  </option>
                  <option value="திருவிழா அலங்காரம் செய்பவர்">
                    திருவிழா அலங்காரம் செய்பவர்
                  </option>
                  <option value="சிற்பி / ஸ்தபதி">சிற்பி / ஸ்தபதி</option>
                  <option value="அலங்காரம் செய்பவர்">அலங்காரம் செய்பவர்</option>
                </select>
              </div>
              <div>
                <input
                  type="text"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  className="w-full p-3 border rounded mt-2"
                  placeholder="Enter keyword name"
                />
              </div>
            </div>
            {errors && <p className="text-red-500 text-sm mt-1">{errors}</p>}
          </div>
          <div className="flex justify-end">
            <button
              onClick={handleSave}
              className="mt-5 bg-blue-500 text-white px-6 py-2 rounded shadow hover:bg-blue-600 transition"
            >
              {editingKeyword ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto mt-8 bg-white shadow-md rounded">
        <div className="p-6">
          <h2 className="text-blue-600 text-xl font-bold mb-6">Keywords</h2>
          <div
            className="ag-theme-alpine"
            style={{ height: 500, width: "100%" }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              pagination={true}
              paginationPageSize={10}
              defaultColDef={{ sortable: true, filter: true, editable:true }}
            />
          </div>
        </div>
      </div>

      {alert.message && (
        <div
          className={`fixed top-20 right-4 px-5 py-3 text-white rounded-lg shadow-lg z-50 ${
            alert.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          <span>{alert.message}</span>
        </div>
      )}
    </div>
  );
};

export default KeywordManager;
